<template>
  <the-page :pageId="pageId" :appConfig="appConfig" class="graph-page" embeddedMode>
    <a-alert
      v-if="!isLoading && !config"
      :message="`Конфигурация с именем 'page_${code}' не найдена`"
      type="info"
      showIcon
    />
    <template v-else-if="config && data">
      <page-block
        v-for="(block, index) of config.pageblocks"
        :key="index"
        :title="getBlockTitle(block, index)"
        :isLoading="loading[index]"
      >
        <a-row v-if="categories" class="stat-page__filters" :gutter="24">
          <a-col :md="6" :lg="8">
            <input-enum
              v-model="date[index]"
              :options="dates[index]"
              :allowClear="false"
              @change="
                (value) => {
                  dateChange(value, index);
                }
              "
            />
          </a-col>
          <a-col :md="6" :lg="8">
            <input-enum
              v-model="category[index]"
              :options="categories"
              :allowClear="false"
              @change="
                (value) => {
                  categoryChange(value, index);
                }
              "
            />
          </a-col>
          <a-col v-if="hasRegions" :md="6" :lg="8">
            <input-enum
              v-model="region[index]"
              :options="regions"
              :allowClear="false"
              @change="
                (value) => {
                  regionChange(value, index);
                }
              "
            />
          </a-col>
        </a-row>
        <div class="graph-page__container">
          <a-alert v-if="hasData(index)" :message="`Нет данных`" type="info" showIcon />
          <IEcharts
            v-else-if="bars[index]"
            :theme="theme"
            :option="bars[index]"
            @ready="
              (instance) => {
                onEchartReady(index, instance);
              }
            "
          />
          <!-- :loading="loading[index]" -->
        </div>
      </page-block>
    </template>
  </the-page>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
import store from '@/store';
import InputEnum from '@/components/base/InputEnum.vue';
import ThePage from '@/components/page/ThePage.vue';
import PageBlock from '@/components/page/PageBlock.vue';
import {storage} from "@/helpers";

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

// const upColorBorder = '#00da3c';
// const downColorBorder = '#ec0000';
// const upColor = 'rgb(0, 218, 60, 0.4)';
// const downColor = 'rgb(236, 0, 0, 0.4)';

const upColorBorder = '#3049c1';
// const downColorBorder = '#3049c1';
const upColor = 'rgb(0, 0, 0, 0)';
// const downColor = 'rgb(0, 0, 0, 0)';

function renderItem(params, api) {
  var xValue = api.value(0);
  // var openPoint = api.coord([xValue, api.value(1)]);
  // var closePoint = api.coord([xValue, api.value(2)]);
  var midPoint = api.coord([xValue, api.value(1)]);
  // var halfWidth = api.size([1, 0])[0] * 0.35;
  var halfWidth = api.size([1, 0])[0] * 0.6 * 0.5;
  var style = { fill: 'green', stroke: upColorBorder };

  return {
    type: 'group',
    children: [
      {
        type: 'line',
        shape: {
          x1: midPoint[0] - halfWidth,
          y1: midPoint[1],
          x2: midPoint[0] + halfWidth,
          y2: midPoint[1],
        },
        style,
      },
    ],
  };
}

export default {
  name: 'TheGraphPage',
  components: {
    IEcharts,
    InputEnum,
    ThePage,
    PageBlock,
  },

  props: {
    appConfig: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      data: [],
      echart: [],
      category: [],
      categories: [],
      date: [],
      dates: [],
      region: [],
      regions: [],
      loading: null,
      isModalVisible: false,
    };
  },

  computed: {
    config() {
      return store.state.activeSidebarItem;
    },
    hasRegions() {
      return !!this.config?.customprops._regions;
    },
    isLoading() {
      return this.loading || this.config === undefined;
    },
    code() {
      return store.state.activeSidebarItem?.code;
    },
    title() {
      return (!this.isLoading && (this.config.customprops.table.title || this.config.title)) || '';
    },
    pageId() {
      return this.$route.params.type;
    },
    bars() {
      if (this.hasRegions) {
        return this.data.map((block /*, index*/) => {
          if (!block) return null;

          const xAxisData = [
            ...new Set([
              ...Object.values(block)[0].fns_data.map((item) => item.date),
              ...Object.values(block)[0].our_data.map((item) => item.date),
            ]),
          ];

          const series = [
            {
              name: 'fns_data',
              type: 'line',
              z: 2,
              data: Object.values(block)[0].fns_data.map((item) => item.avg_price),
              tooltip: {
                formatter(param) {
                  return [`<b>${param.name}</b></br>`, `Средняя цена: ${param.data} </br>`].join(
                    '',
                  );
                },
              },
            },
            // {
            //   name: 'our_data',
            //   type: 'line',
            //   data: Object.values(block)[0].our_data.map((item) => item['average price']),
            // },
            {
              name: 'avg',
              type: 'custom',
              z: 1,
              renderItem,
              dimensions: [null, 'mediana'],
              encode: {
                x: 0,
                y: [1],
                // tooltip: {},
              },
              data: Object.values(block)[0].our_data.map((item) => [
                item.date,
                item.mediana,
                item.min,
                item.max,
              ]),
              tooltip: {
                formatter: () => '',
              },
            },
            {
              name: 'our_data',
              z: 0,
              barWidth: '60%',
              // barMaxWidth: 10,
              type: 'candlestick',
              data: Object.values(block)[0].our_data.map((item) => [
                item.q1,
                item.q3,
                item.min,
                item.max,
              ]),
              tooltip: {
                formatter(param) {
                  param = param.data;
                  const data = Object.values(block)[0].our_data[param[0]];
                  return [
                    `<b>${data.date}</b></br>`,
                    `Средняя цена: ${data['average price']} </br>`,
                    `Количество покупок для подсчета: ${data.price_count} </br>`,
                    `Дисперсия: ${data.disp} </br>`,
                    `Медиана: ${data.mediana} </br>`,
                    `Минимальная цена: ${data.min} </br>`,
                    `Максимальная цена: ${data.max} </br>`,
                  ].join('');
                },
              },
              itemStyle: {
                color: upColor,
                color0: upColor,
                borderColor: upColorBorder,
                borderColor0: upColorBorder,
                borderWidth: 1,
                // opacity: 0.2,
              },
            },
          ];

          const option = {
            tooltip: {},
            backgroundColor: 'transparent',
            yAxis: {},
            xAxis: {
              data: xAxisData,
            },
            // brush: {
            //   // xAxisIndex: 'all',
            //   // brushLink: 'all',
            //   outOfBrush: {
            //     colorAlpha: 0.1
            //   }
            // },
            series,
            // legend: {
            //   data: Object.keys(block),
            //   selected: Object.keys(block).reduce((sum, key, ind) => {
            //     sum[key] = ind < 5;
            //     return sum;
            //   }, {}),

            //   type: 'scroll',
            //   orient: 'vertical',
            //   right: 10,
            //   top: 0,
            //   bottom: 120,
            //   pageTextStyle: {
            //     color: store.state.darkTheme ? '#f0f0f0' : '#222',
            //   },
            //   pageIconColor: '#66B2C2',
            // },
            // grid: {
            //   left: 100,
            //   right: 350,
            // },
          };

          return option;
        });
      }

      return this.data.map((block, index) => {
        const conf = this.config.pageblocks[index].graph;
        if (!block) return null;

        const option = {
          tooltip: {},
          backgroundColor: 'transparent',
          yAxis: {},
          xAxis: {
            data: [
              ...new Set(
                Object.values(block)
                  .map((group) => Object.values(group).map((item) => item.date))
                  .flat(),
              ),
            ],
          },
          series: Object.entries(block).map(([key, group]) => ({
            name: key,
            type: conf.type,
            data: Object.values(group).map((item) => item.circulation),
          })),
          legend: {
            data: Object.keys(block),
            selected: Object.keys(block).reduce((sum, key, ind) => {
              sum[key] = ind < 5;
              return sum;
            }, {}),

            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 0,
            bottom: 120,
            pageTextStyle: {
              color: store.state.darkTheme ? '#f0f0f0' : '#222',
            },
            pageIconColor: '#66B2C2',
          },
          grid: {
            left: 100,
            right: 350,
          },
        };

        if (['bar', 'line'].includes(conf.type)) return option;
        return null;
      });
    },
    theme() {
      return store.state.darkTheme ? 'dark' : 'light';
    },
  },

  watch: {
    config: {
      immediate: true,
      async handler(value) {
        if (value) {
          this.region = new Array(this.config.pageblocks.length).fill(null);
          this.category = new Array(this.config.pageblocks.length).fill(null);
          this.date = new Array(this.config.pageblocks.length).fill(null);
          this.data = new Array(this.config.pageblocks.length).fill(null);
          this.loading = new Array(this.config.pageblocks.length).fill(true);
          await this.requestCategories();

          if (this.hasRegions) {
            await this.requestRegions();
          }

          this.requestData();
        }
      },
    },
    theme() {
      const data = this.data;
      this.data = null;
      this.$nextTick(() => {
        this.data = data;
      });
    },
  },

  async mounted() {
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.echart?.forEach((chart) => {
          chart.resize();
        });
      }, 200);
    });
  },

  methods: {
    hasData(index) {
      return this.data?.[index] && !Object.keys(this.data[index]).length;
    },

    dateChange(value, index) {
      this.requestBlockData(this.config.pageblocks[index], index, false);
    },

    categoryChange(value, index) {
      this.requestBlockData(this.config.pageblocks[index], index);
    },

    regionChange(value, index) {
      this.requestBlockData(this.config.pageblocks[index], index);
    },

    getBlockTitle(block, index) {
      if (!this.config) {
        return '';
      }

      if (!block.title && index === 0) {
        return store.state.activeSidebarItem?.title;
      }

      return block.title;
    },
    async requestCategories() {
      const categories = await this.axios.get(
        `${apiUrl}/report${this.hasRegions ? '/average_price' : ''}/get_categories`,
        // {
        //     headers: {
        //       'finch-auth': `Bearer ${storage.get('authToken')}`
        //     }
        //   }
      );
      this.categories = categories.data;
      if (!this.hasRegions) {
        this.categories = categories.data.filter((category) =>
          [
            'Водка крепостью 40% об.спирта и выше',
            'Сахар-песок',
            'Майонез',
            'Кетчуп',
            'Картофель',
            'Яблоки, кг',
            'Морковь',
            'Бананы',
            'Йогурт',
          ].includes(category),
        );
      }
      this.category = [...this.category].fill(this.categories[0]);
    },
    async requestRegions() {
      const regions = await this.axios.get(`${apiUrl}${this.config?.customprops._regions}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          });
      this.regions = regions.data;
      this.region = [...this.region].fill(this.regions[0]);
    },
    async requestData() {
      if (!this.config) return;

      this.data = new Array(this.config.pageblocks.length).fill(null);
      this.config.pageblocks.map(this.requestBlockData);
    },
    async requestBlockData(block, index, updateDates = true) {
      if (updateDates) {
        const prevDate = this.date[index];

        const dates = await this.axios.get(`${apiUrl}${block.datesListUrl}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          });
        this.dates[index] = dates.data;

        if (!this.dates[index].includes(prevDate)) {
          const blocksDates = this.date;
          blocksDates.splice(index, 1, dates.data[0]);
          this.date = blocksDates;
        }
      }

      // /api-stat/report/average_price/get_month_list

      // this.echart[index]?.showLoading({
      //   text: 'Зарузка...',
      //   textColor: '#fff', //font color
      //   color: '#0affff', //Load animation color
      //   textStyle: {fontSize: 30, color: '#fff'},
      //   maskColor: 'rgba(0, 0, 0, 0.4)',
      // });

      this.loading[index] = true;
      const { data } = await this.axios.get(
        `${apiUrl}${block.source}${this.hasRegions ? '_v2' : ''}`,
        {
          params: {
            category: this.category[index],
            date: this.date[index],
            region: this.region[index],
          },
          // headers: {
          //   'finch-auth': `Bearer ${storage.get('authToken')}`
          // }
        }
      );
      const blocksData = this.data;
      blocksData.splice(index, 1, data);
      this.data = blocksData;
      this.loading[index] = false;
      // this.echart[index].hideLoading();
    },
    onEchartReady(index, instance) {
      this.echart[index] = instance;
    },
  },
};
</script>

<style lang="scss">
.graph-page {
  &__container {
    height: 600px;
    width: 100%;
  }
}
</style>
